import { HttpParams } from "@angular/common/http";
import { forwardRef, Inject, Injectable } from "@angular/core";
import { firstValueFrom } from "rxjs";
import { USER_EVENTS_V2, USER_HISTORICAL_EVENTS_V2 } from "../common/endpoints";
import { PagedList, ThingAlertStatus } from "../model";
import { HttpService } from "./http.service";

@Injectable()
export class UserEventService {

    constructor(
        @Inject(forwardRef(() => HttpService)) private httpService: HttpService
    ) { }

    getRecursivelyAllEvents(page: number, isActive: boolean, events: ThingAlertStatus[], params?: HttpParams): Promise<ThingAlertStatus[]> {
        if (!page) {
            page = 0;
        }
        if (!events) {
            events = [];
        }
        return this.getEventPagedList(page, 200, isActive, params)
            .then(pagedEvents => {
                events = events.concat(pagedEvents.content);
                if (pagedEvents.last) {
                    return events;
                } else {
                    return this.getRecursivelyAllEvents(++page, isActive, events);
                }
            });
    }

    private getEventPagedList(page: number, size: number, isActive: boolean, params?: HttpParams): Promise<PagedList<ThingAlertStatus>> {
        if (!params) {
            params = new HttpParams();
        }
        params = params.set('page', page + '');
        params = params.set('size', size + '');
        return firstValueFrom(this.httpService.get<PagedList<ThingAlertStatus>>(isActive ? USER_EVENTS_V2 : USER_HISTORICAL_EVENTS_V2, params));
    }
}